import {animate, AnimationTriggerMetadata, query, style, transition, trigger} from '@angular/animations';

export function componentEnterLeaveAnimation(): AnimationTriggerMetadata {
  return trigger('ComponentEnterLeaveAnimation', [
    transition('false => true', [
      query(
        '.details:enter',
        [
          style({
            left: '100%'
          }),
          animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({left: '0'}))
        ],
        {optional: true}
      )
    ]),
    transition('true => false', [
      query(
        '.details:leave',
        [
          style({
            left: '0'
          }),
          animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({left: '100%'}))
        ],
        {optional: true}
      )
    ])
  ]);
}
